<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/authors#aunote">Author’s Note</a></p>
<p class="toc"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/foreword#foreword">Foreword by Ann Rule</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1"><span class="epub-b">1</span>. Early Days</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2"><span class="epub-b">2</span>. From Rookie to Undercover Ace</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="epub-b">3</span>. Blood, Drugs, and Murder in Multnomah County</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="epub-b">4</span>. Chronicles of a Crime Scene Reconstructionist</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="epub-b">5</span>. Blood Basics</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="epub-b">6</span>. Celebrity Cases</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="epub-b">7</span>. Cold Blood</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="epub-b">8</span>. A World of Crime</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="epub-b">9</span>. Trials and Errors</span></p>
<p class="toc"><span href="#/xhtml/note#note" title="Link target outside of Sample">Note</span></p>
<p class="toc"><span href="#/xhtml/afterword#after" title="Link target outside of Sample">Afterword: A Glimpse of the Future</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?aa8bf1bc